var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadBrandlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.025,
    height: 37.025,
    viewBox: "0 0 37.025 37.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_img",
    "data-name": "vuesax/bulk/img",
    transform: "translate(-492 -252)",
    opacity: 0.503
  }, /*#__PURE__*/React.createElement("g", {
    id: "img",
    transform: "translate(492 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.854,8.963v9.549H24.56a3.383,3.383,0,0,1-2.731-1.651l-1.6-3.039c-.432-.818-1.049-.771-1.388.077l-3.548,8.963c-.386,1-1.034,1-1.435,0L12.095,18.42a3.319,3.319,0,0,0-2.869-1.959L0,16.507V8.963C0,3.348,3.348,0,8.963,0H21.891C27.507,0,30.854,3.348,30.854,8.963Z",
    transform: "translate(3.085 3.085)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M30.854,8.656V5.277H24.56A3.383,3.383,0,0,1,21.83,3.626L20.225.587c-.432-.818-1.049-.771-1.388.077L15.288,9.627c-.386,1-1.034,1-1.435,0L12.095,5.184A3.319,3.319,0,0,0,9.225,3.225L0,3.271V8.656c0,5.523,3.24,8.855,8.686,8.948.17.015.355.015.525.015H21.552c.231,0,.463,0,.679-.015C27.646,17.48,30.854,14.163,30.854,8.656Z",
    transform: "translate(3.085 16.321)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.046,0V5.106C.015,4.613,0,4.088,0,3.548V0Z",
    transform: "translate(3.039 19.593)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H37.025V37.025H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(10.513 12.513)",
    fill: "#282c30"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBrandlogo);
export default __webpack_public_path__ + "static/media/upload-brandlogo.1854392a692d7ad497ef3c80392244df.svg";
export { ForwardRef as ReactComponent };